import React, { Component } from "react"
import BookingStarter from "../bookingStarter"
import config from "react-global-configuration"
import * as tracking from "../../helpers/tracking"

class ParkingTimeModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isTracked: false,
    }
  }

  componentDidMount() {
    if (!this.state.isTracked) {
      tracking.trackPageView(this.props, "parking", `/virtual/(|en/|sv/)parkering/dates${this.props.useNewDesign ? "?newDesign=true" : ""}`)
      this.setState({ isTracked: true })
    }
  }

  render() {
    const textKeys = config.get("textKeys.basket.timeModal") || {}
    const { arrivalDate, arrivalTime, departureDate, departureTime, voucher, affiliateCode } = this.props
    return (
      <div className="overlay overlay--modal overlay--fixed is-active">
        <div className="modal modal--takeover">
          <button className="button button--icon js--close-modal" onClick={() => this.props.parkingTimeModalToogle()}>
            <span className="icon">
              <svg className="svg-icon svg-icon--close-new">
                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-close-new">
                  &nbsp;
                </use>
              </svg>
            </span>
          </button>
          <div className="modal__content">
            <div className="modal__content__inner">
              <div className="modal__middle">
                {/* <div className="parking-time-picker__header">
                                            <span className="icon">
                                                <svg className="svg-icon svg-icon--parking">
                                                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-parking">&nbsp;</use>
                                                </svg>
                                            </span>
                                            <h2>{textKeys.newBooking || "Foretag ny booking"}</h2>
                                        </div> */}
                <BookingStarter
                  searchData={{
                    ad: arrivalDate,
                    at: arrivalTime,
                    dd: departureDate,
                    dt: departureTime,
                    voucher,
                    affiliateCode,
                  }}
                  textKeys={config.get("textKeys.bookingStarter") || {}}
                  performParkingSearch={this.props.performParkingSearch}
                  performChangeBookingSearch={this.props.performChangeBookingSearch}
                  isInModal={true}
                  parkingTimeModalToogle={this.props.parkingTimeModalToogle}
                  showDefaultDates={true}
                  location={this.props.location}
                  campaignCode={false}
                  headline={textKeys.modalHeadline || "Book parkering"}
                  button={textKeys.modalButtonText || "Book nu"}
                  replaceHistory={false}
                  searchOnBlur={false}
                  leadTimeInHours={this.props.leadTimeInHours || 1}
                />
                <div className="w--normal"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default ParkingTimeModal
